// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___3h_l9","subject":"styles__subject___2WUNs","infoContainer":"styles__infoContainer___39Gru","infoText":"styles__infoText___3195Z","message":"styles__message___3hEKR"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/queue-panel/note-details/styles.css
// module id = 1094
// module chunks = 0